export default {
    modelReady: true,
    sourceType: 1,
    minBuyCount: 1,
    servicePhones: [{
        phone: '',
        startHour: 0,
        startMin: 0,
        endHour: 0,
        endMin: 0
    }],
    contractInfoType: 1,
    contractInfoRule: {
        mobile: false
    },
    visitorInfoType: 2,
    visitorInfoGroupSize: 2,
    visitorInfoRule: {
        name: true,
        credentials: false,
        mobile: false
    },
    aheadHoursType: 1,
    aheadHours: 0,
    minutes: 30,
    aheadDays: 0,
    hours: 0,
    orderCancelTime: 30,
    baseMsRatioSnapshot: null,
    voucherTimes: [{
        voucherStartTime: 0,
        voucherEndTime: 23 * 60 + 59,
        needVoucherOrGetInTimeSupplement: false,
        voucherOrGetInTimeSupplement:''
    }],
    getVoucherRule: {
        needCertificateSupplement: false,
        certificateSupplement: '',
        voucherLoaders: [1]
    },
    getTicketRule: {
        needCertificateSupplement: false,
        certificateSupplement: '',
        voucherLoaders: [1]
    },
    generateTicketWorkTime: {
        startWorkHour: 8,
        startWorkMinute: 0,
        endWorkHour: 20,
        endWorkMinute: 0
    },
    needTicket: false,
    ticketGetAddress: [''],
    getInAddresses: [''],
    otherNote: '',
    // images
    dealImageInfos: [],
    includeItems: [{
        count: 1
    }],
    include: '',
    exclude: '',
    stock: null,
    stockType: 1,
    sellType: 1,
    useDateMode: 0,
    useDateDays: null,
    scheduleOfflineType: 1,
    scheduleOfflineTime: null,
    refundFeeMode: 1,
    refundFee: null,
    refundTimeType: 2,
    refundLimitDays: null,
    refundLimitHours: null,
    refundLimitMinutes: null,
    unavailableDates: [],
    partlyRefund: true,
    freeTicketType: null,
    associatedContractList: [],
    freeTicketAssociatedAccount: '',
    freeTicketAssociatedDetail: '',
    statementId: null,
    marketPrice: null,
    validWeekRule: {
        'monday': true,
        'tuesday': true,
        'wednesday': true,
        'thursday': true,
        'friday': true,
        'saturday': true,
        'sunday': true
    },
    voucherDateBegin: null,
    voucherDateEnd: null,
    needSpecialAuthFile: false,
    specialMsRatioReasonType: 1,
    specialMsRatioReason: '',
    onlineMsRatioPriceInfo: {},
    specialAuthPics: [],
    specialAuthPicsShow: [],
    mtPrice: null,
    settlementPrice: null,
    refundType: 2, // 极速退
    scheduleOnlineType: 1,
    scheduleOnlineTime: null,
    dayPriceStockRules: [],
    generateTicketMethod: 1,
    containInsurance: false,
    ticketCategory: {
        ticket: {},
        subTicket: {},
        poi: [],
        createTicketCategoryInfo: {
            ticketCategoryName: '',
            usePeople: 1,
            timeLimitedRange: 3,
            timeLimitedRangeText: '',
            ticketCategoryPrice: '',
            uploadMaterialType: 2,
            uploadMaterialText: '',
            uploadMaterialImage: []
        }
    },
    ticketPoiDiscounts: [],
    title: '',
    mtCategory: null,
    contractId: null,
    contractNum: null,
    isAllAvailable: true,
    availableCount: 1,
    scrAttrs:{
        needBookOffline: false,
        offlineBookRule: {
            bookTypes: []
        }
    },
    bindedBizAccountId: [],
    phoneLimitDays: 1,
    limitDayType: 0,
    phoneLimitUnitType: 0,
    idLimitDays: 1,
    idLimitUnitType: 0,
    // 剧场票
    theatreWhiteList: false,
    partnerDealId: '',
    IAmTheatre: false, // 辅助字段，便于各个tab数据共享
    ticketPriceType: 0, // 产品类型
    canSeatSelection: false, // 是否支持在线选座
    seatImage: '', // 座位图片
    seatImageShow: [],
    needAheadSupplement: false,
    aheadHoursBeforeUse: 0,
    aheadMinutesBeforeUse: 30,
    returnVoucher: true, //下单时是否传回凭证
    voucherText: '', //不传回凭证时的文案
    hasRefundLimitTime: false,
    canRefundCurrentDate: true,
    oPCanRefundCurrentDate: false,
    refundLimitHourFrom: 8,
    refundLimitMinuteFrom: 0,
    refundLimitHourTo: 21,
    refundLimitMinuteTo: 0,
    refundStairsRules: [{
        refundFeeMode: 1,
        refundFee: 0,
        refundFeeDump: 0,
        refundTimeType: 2,
        aheadDays: 0,
        hours: 0,
        minutes: 0,
        refundLimitMinutes: null
    }],
    refundNote: '',
    supplierProtocolRule: {
        rebateProtocols: [],
        packageProtocols: []
    },
    insuranceNote: ''
};


// WEBPACK FOOTER //
// ./src/views/ticket/product/common/modelSchema.js